import React from 'react';
import "katex/dist/katex.min.css";
import BiggestRatingChanges from '../../components/BiggestRatingChanges';
import { useOutletContext } from 'react-router-dom';

export default function PlayersOfTheWeek() {
    const [gameMode] = useOutletContext()
    return <BiggestRatingChanges gameMode={gameMode.key}></BiggestRatingChanges>
}